export function formatAmount(value) {
  const rounded = Math.round(value * 100) / 100;
  return rounded.toLocaleString(undefined, { maximumFractionDigits: 2 });
}

export function formatCompactAmount(value) {
  const abs = Math.abs(value);

  if (abs >= 1_000_000) {
    return `${(value / 1_000_000).toFixed(1)}M`;
  }

  if (abs >= 10_000) {
    return `${(value / 1_000).toFixed(1)}K`;
  }

  return formatAmount(value);
}
